import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClienteInserirComponent } from './cliente-inserir.component'; 


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: ClienteInserirComponent }
    ])],
    exports: [RouterModule]
})
export class ClienteInserirRoutingModule { }
